import React from "react";
import Lightbox, { LightboxExternalProps } from "yet-another-react-lightbox";
import "yet-another-react-lightbox/styles.css";
import Zoom from "yet-another-react-lightbox/plugins/zoom";
import Thumbnails from "yet-another-react-lightbox/plugins/thumbnails";
import "yet-another-react-lightbox/plugins/thumbnails.css";

export interface YetAnotherReactLightBoxProps extends LightboxExternalProps {}

const YetAnotherReactLightBox: React.FC<YetAnotherReactLightBoxProps> = ({
  ...restProps
}) => {
  return <Lightbox plugins={[Zoom, Thumbnails]} {...restProps} />;
};

export default YetAnotherReactLightBox;
